import { POPULAR_INSTRUMENTS_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getPopularInstruments = () => {
  return myFetch(`${POPULAR_INSTRUMENTS_ENDPOINT}`, "GET");
};
